import {
  RECEIVE_RETAILER_SETTINGS,
  SET_DISPLAY_RETURN_METHOD,
  SET_REQUIRED_CONDITIONS,
} from '../../actions/retailerSettings';

export const initialState = {
  displayReturnMethod: false,
  requiredConditions: {},
};

export default (
  state = initialState,
  {
    type,
    data: {
      retailerSettings = {},
      displayReturnMethod,
      requiredConditions,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_RETAILER_SETTINGS:
      return { ...state, ...retailerSettings };

    case SET_DISPLAY_RETURN_METHOD:
      return { ...state, displayReturnMethod };

    case SET_REQUIRED_CONDITIONS:
      return { ...state, requiredConditions };

    default:
      return state;
  }
};
